import { useContext } from 'react'
import { GlobalContext } from 'App'
import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';
import Contact1 from 'assets/Contact/contact1.avif'
import Contact2 from 'assets/Contact/contact2.avif'
import Contact2Mo from 'assets/Contact/contact2Mo.avif'

const First = ({ activeIndex }: any) => {
  const { isTablet } = useContext(GlobalContext)

  return (
    <div className={`flex w-full h-screen overflow-hidden justify-center items-center bg-black`}
      style={{
        backgroundImage: `url(${isTablet ? Contact2Mo : Contact2})`,
        backgroundSize: 'cover', // 이미지 크기 조정
        backgroundPosition: 'center', // 이미지 위치
        backgroundRepeat: 'no-repeat', // 이미지 반복 제거
        width: '100%',
        height: 'calc(var(--vh, 1vh) * 100)', // 원하는 높이 설정
      }}>
      <div className='tablet:flex tablet:flex-col tablet:justify-end tablet:px-0 tablet:h-full container'>
        <motion.p
          className='mb-16 tablet:mb-4 tablet:px-6 text-white tablet:text-32 text-8xl'
          style={{ textShadow: '0 0 14px white' }}
          initial={START_ANIMATION_PROPERTY}
          whileInView={END_ANIMATION_PROPERTY}
          viewport={VIEWPORT_PROPERTY} >
          CONTACT
        </motion.p>

        <motion.img
          className='mb-7.5 tablet:mb-0 tablet:h-63 object-cover'
          src={Contact1}
          transition={{ delay: 0.2 }}
          alt="contact"
          initial={START_ANIMATION_PROPERTY}
          whileInView={END_ANIMATION_PROPERTY}
          viewport={VIEWPORT_PROPERTY} >
        </motion.img>

        <div className='tablet:p-6 tablet:pb-24'>
          <motion.p
            className='text-[#5F5F5F] tablet:text-xs text-lg'
            transition={{ delay: 0.4 }}
            initial={START_ANIMATION_PROPERTY}
            whileInView={END_ANIMATION_PROPERTY}
            viewport={VIEWPORT_PROPERTY} >
            주소 : 서울특별시 강서구 마곡중앙8로 14, 서울창업허브M+ 408호
          </motion.p>
          <motion.p
            className='text-[#5F5F5F] tablet:text-xs text-lg'
            transition={{ delay: 0.4 }}
            initial={START_ANIMATION_PROPERTY}
            whileInView={END_ANIMATION_PROPERTY}
            viewport={VIEWPORT_PROPERTY} >
            대표 팩스 : sales@tinslab.co.kr
          </motion.p>
          <motion.p
            className='text-[#5F5F5F] tablet:text-xs text-lg'
            transition={{ delay: 0.4 }}
            initial={START_ANIMATION_PROPERTY}
            whileInView={END_ANIMATION_PROPERTY}
            viewport={VIEWPORT_PROPERTY} >
            대표 연락처 : 02-2132-8688
          </motion.p>
          <motion.p
            className='text-[#5F5F5F] tablet:text-xs text-lg'
            transition={{ delay: 0.4 }}
            initial={START_ANIMATION_PROPERTY}
            whileInView={END_ANIMATION_PROPERTY}
            viewport={VIEWPORT_PROPERTY} >
            대표 이메일 : sales@tinslab.co.kr
          </motion.p>
        </div>
      </div>
    </div>
  )
}



export default First